<div class="c-tags-input {{classList}} {{#if inputIcon}}with-input-icon{{/if}} {{#unless value}}no-values{{/unless}} {{#if error}}error{{/if}} {{#if isDisabled}}disabled{{/if}}">
	<div class="c-tags-input_info">
		<span class="c-tags-input_info_label">
			{{labelText}}
			{{#if @this.partials.labelIcon}}
				{{>labelIcon}}
			{{/if}}
		</span>

		{{#if error}}
			<span class="c-tags-input_info_errorMsg">
				{{error}}
			</span>
		{{/if}}
	</div>

	<div class="c-tags-input_tags-block {{#if tagsArr &&tagsArr.length === this.maxTagsAllowed}}full{{/if}} {{#if error}}has-error{{/if}}"
		id="{{inputWrapperIdPrefix + inputId}}">
		{{#if tagsArr && tagsArr.length}}
			<div class="c-tags-input_tags-block_tags-list">
				{{#each tagsArr:tagIdx}}
					<div class="c-tags-input_tags-block_tags-list_tag">
						<span class="c-tags-input_tags-block_tags-list_tag_text" on-click="@this.onTagClick(tagIdx)">
							{{this}}
						</span>

						<img class="c-tags-input_tags-block_tags-list_tag_close-icon"
							width="16"
							height="16"
							on-click="@this.removeTagByIdx(tagIdx)"
							src="{{@shared.assetsHost}}/img/tag-input-close-icon.svg">
					</div>
				{{/each}}
			</div>
		{{/if}}

		{{#if !value && inputIcon}}
			<img class="c-tags-input_input-icon"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/{{inputIcon}}">
		{{/if}}

		{{#if error}}
			<img class="c-tags-input_tags-block_err-icon"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/alert-icon.svg">
		{{/if}}

		<input
			id="{{inputId}}"
			value="{{inputValue}}"
			type="text"
			placeholder="{{placeholder}}"
			class="{{#if tagsArr.length >= maxTagsAllowed}}tags-limit{{/if}} {{#if isDisabled}}disabled-input{{/if}}">

		{{#if showIPSwitch}}
			<div tabindex="0" class="switch-ip-type-wrapper {{#if isDisabled}}disabled{{/if}} {{#unless ipVersionDisplayed}}hidden{{/unless}} {{#if ipSwitchLocked}}locked{{/if}}">
				<input id="switch-ip-type"
					type="checkbox"
					twoway="false"
					class="switch-input {{#unless ipVersionDisplayed === IP_V4_VALUE}}checked{{/unless}}">

				<label for="switch-ip-type">
					<span on-click="@this.handleIpVersionSwitch(IP_V4_VALUE)">IPv4</span>
					<span on-click="@this.handleIpVersionSwitch(IP_V6_VALUE)">IPv6</span>
				</label>
			</div>
		{{/if}}
	</div>
</div>

<script>
	const ipRegex = require('../../assets/js/utils/ip-regex');
	const listeners = require('../../assets/js/utils/listeners');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const IP_V4_VALUE = 4;
	const IP_V6_VALUE = 6;

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				invalidValue: null,
				errMsgTopPos: false,
				inputValue: '',
				inputWrapperIdPrefix: 'tags-block-',
				valuesDelimiter: ',',
				maxTagsAllowed: 2,
				tagsArr: [],
				isDisabled: false,
				useGpTargetHandler: false,
				// ipVersion should be set only for 1 target when it is a domain name
				ipVersion: null,
				ipVersionDisplayed: null,
				ipSwitchLocked: false,
				IP_V4_VALUE,
				IP_V6_VALUE,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('error', (error) => {
					if (error) {
						this.set('invalidValue', this.get('value'));
						this.set('ipVersion', null);
						this.set('ipVersionDisplayed', null);
					} else {
						this.handleIpSwitchState();
					}
				}, { init: false });

				this.observe('value', (value) => {
					let invalidValue = this.get('invalidValue');
					let error = this.get('error');

					if (error && invalidValue !== value) {
						this.set('error', undefined);
					}
				});

				this.observe('screenWidth', (screenWidth) => {
					if ((screenWidth || window.innerWidth) < 768) {
						this.set('errMsgTopPos', true);
					} else {
						this.set('errMsgTopPos', false);
					}
				});

				this.observe('value', (value) => {
					let valuesDelimiter = this.get('valuesDelimiter');
					this.set('tagsArr', value ? value.split(valuesDelimiter).map(tag => tag.trim()) : []);
				});

				// handle ip type switch
				this.observe('tagsArr', () => {
					this.handleIpSwitchState();
				});

				// set default value is it was passed as prop
				this.observe('defaultValue', (defaultValue) => {
					let setDefaultValueInitially = this.get('setDefaultValueInitially');

					if (defaultValue && setDefaultValueInitially) {
						this.set('value', defaultValue);
					}
				});

				// for share-results case we need to set displayed value
				this.observe('ipVersion', (ipVersion) => {
					this.set('ipVersionDisplayed', ipVersion);
				});
			}
		},
		onrender () {
			listeners.screenWidthListener(this);
		},
		oncomplete () {
			if (!Ractive.isServer) {
				let inputWrapperIdPrefix = this.get('inputWrapperIdPrefix');
				let inputId = this.get('inputId');
				let inputEl = this.find(`#${inputId}`);
				let ipTypeSwitchEl = this.find('.switch-ip-type-wrapper');
				let tagsBlockEl = this.find(`#${inputWrapperIdPrefix + inputId}`);

				// handle input changes
				inputEl.addEventListener('keydown', (e) => {
					let currMaxTagsAllowed = this.get('maxTagsAllowed');
					let currTagsArr = this.get('tagsArr');
					let inputValue = this.get('inputValue');
					let defaultValue = this.get('defaultValue');

					if (this.get('isDisabled')) {
						e.preventDefault();

						return;
					}

					// while there are already max tags and key is not Backspace - ignore input changes
					if (currTagsArr.length === currMaxTagsAllowed && e.key !== 'Tab' && e.key !== 'Backspace' && e.key !== 'Enter') {
						e.preventDefault();

						return;
					}

					// if input has some value which is not added as tag yet - add tag on Enter/Tab, on second Enter/Tab run measurement/switch to the next field
					// if user did not passed any value, on Enter add default one, if presented, and run measurement
					// handle keys for adding new tags, removing tags, allow to bubble event on Enter key etc.
					if ([ 'Enter', 'Tab' ].includes(e.key) && !inputValue) {
						if (defaultValue && currTagsArr.length === 0) {
							this.set('value', defaultValue);
						}

						tagsBlockEl.classList.remove('focused');
					} else if ([ 'Enter', 'Tab', ' ', ',' ].includes(e.key)) {
						this.addTag();

						// Prevent Enter always and Tab when only 1 target is filled
						if (e.key === 'Enter') {
							e.preventDefault();
						}

						if (e.key === 'Tab') {
							if (currTagsArr.length < currMaxTagsAllowed) {
								e.preventDefault();
							} else {
								tagsBlockEl.classList.remove('focused');
							}
						}
					} else if (e.key === 'Backspace') {
						this.removeLastTag();
					}
				});

				// on focusout add the content of the input as a tag if it matches conditions
				inputEl.addEventListener('focusout', () => {
					let inputValue = this.get('inputValue');
					let tagsArr = this.get('tagsArr');
					let defaultValue = this.get('defaultValue');

					// set default value if user did not fill in something and focusout
					if (defaultValue && !inputValue && tagsArr.length === 0) {
						this.set('value', defaultValue);
					} else {
						this.addTag();
					}
				});

				// handle focus styles
				tagsBlockEl.addEventListener('click', (e) => {
					let switchIpTypeEl = this.find('.switch-ip-type-wrapper');

					if (!switchIpTypeEl.contains(e.target)) {
						this.handleInputFocus(tagsBlockEl);
					}
				});

				inputEl.addEventListener('focus', () => {
					this.handleInputFocus(tagsBlockEl);
				});

				let handleOnClickOutside = (e) => {
					if (e.target.isConnected && !tagsBlockEl.contains(e.target)) {
						tagsBlockEl.classList.remove('focused');
					}
				};

				listeners.addManagedListener(this, document, 'click', handleOnClickOutside);

				this.observe('isDisabled', (isDisabled) => {
					if (isDisabled) {
						tagsBlockEl.classList.remove('focused');
					}
				});

				// handle paste event
				inputEl.addEventListener('paste', (event) => {
					event.preventDefault();
					let rawPasteContent = (event.clipboardData || window.clipboardData).getData('text').trim();
					let tagsArr = this.get('tagsArr');
					let valuesDelimiter = this.get('valuesDelimiter');

					this.handleOptsOnTargetInputFullURL(rawPasteContent, tagsArr, valuesDelimiter);
				});

				// toggle IP version switch on SPACE
				ipTypeSwitchEl.addEventListener('keydown', (e) => {
					if ([ ' ' ].includes(e.key)) {
						e.stopPropagation();
						e.preventDefault();

						let ipVersion = this.get('ipVersion');
						let ipVersionDisplayed = this.get('ipVersionDisplayed') || IP_V4_VALUE;
						let ipSwitchLocked = this.get('ipSwitchLocked');

						if (!ipSwitchLocked) {
							this.set('ipVersion', ipVersion === null ? ipVersion : ipVersion === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
							this.set('ipVersionDisplayed', ipVersionDisplayed === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
						}
					}
				});

				ipTypeSwitchEl.addEventListener('focus', (e) => {
					this.handleIpTypeSwitchFocus(e, tagsBlockEl);
				});
			}
		},
		addTag (clearInput = true) {
			let maxTagsAllowed = this.get('maxTagsAllowed');
			let valuesDelimiter = this.get('valuesDelimiter');
			let inputValue = this.get('inputValue').trim();
			let tagsArr = this.get('tagsArr');

			if (tagsArr.length < maxTagsAllowed) {
				if (!tagsArr.includes(inputValue) && inputValue !== '') {
					let updTagsArr = [ ...tagsArr, inputValue ];
					let targetInputValue = updTagsArr.join(valuesDelimiter);

					if (this.get('useGpTargetHandler')) {
						this.handleOptsOnTargetInputFullURL(inputValue, tagsArr, valuesDelimiter);
					} else {
						this.set('value', targetInputValue);
					}
				}

				// to overwrite inputValues as ',' or '' set by browser we should call it via setTimeout
				if (clearInput) {
					setTimeout(() => {
						this.set('inputValue', '');
					}, 4);
				}
			}
		},
		removeLastTag () {
			let valuesDelimiter = this.get('valuesDelimiter');
			let inputValue = this.get('inputValue');
			let tagsArr = this.get('tagsArr');

			if (inputValue === '') {
				tagsArr.pop();

				this.set('value', tagsArr.join(valuesDelimiter));
			}
		},
		removeTagByIdx (tagIdx) {
			if (this.get('isDisabled')) { return; }

			let valuesDelimiter = this.get('valuesDelimiter');
			let tagsArr = this.get('tagsArr');

			tagsArr.splice(tagIdx, 1);

			this.set('value', tagsArr.join(valuesDelimiter));

			// set back focus to the input
			let inputId = this.get('inputId');
			let inputEl = this.find(`#${inputId}`);

			inputEl.focus();
		},
		handleInputFocus (tagsBlockEl) {
			let isDisabled = this.get('isDisabled');
			let defaultValue = this.get('defaultValue');
			let currentValue = this.get('value');

			if (!isDisabled && !tagsBlockEl.classList.contains('focused')) {
				tagsBlockEl.classList.add('focused');

				// clear default tag on focus
				if (defaultValue && currentValue && currentValue === defaultValue) {
					this.set('value', '');
				}
			}
		},
		onTagClick (index) {
			this.addTag(false);
			this.set('inputValue', this.get('tagsArr')[index]);
			this.removeTagByIdx(index);
		},
		handleOptsOnTargetInputFullURL (url, tagsArr = null, delimiter = null) {
			try {
				let { protocol, port, pathname, hostname, search } = new URL(url);
				pathname = pathname !== '/' ? pathname : '';
				search = search.replace('?', '');

				if (!hostname) {
					// Just one extra check. The constructor above may throw too.
					throw new Error('Invalid URL');
				}

				if (pathname || search) {
					this.set('gpMainOpts.type', 'HTTP');
				}

				if (this.get('gpMainOpts.type') === 'HTTP') {
					this.set('gpHttpOpts.protocol', protocol.replace(':', '').toUpperCase());
					this.set('gpNotAppliedOpts.request.path', pathname);
					this.set('gpNotAppliedOpts.request.query', search);
				}

				this.set('gpMainOpts.target', tagsArr ? [ ...tagsArr, hostname ].join(delimiter) : hostname);
				this.set('gpNotAppliedOpts.port', port);
				this.set('tagsArr', tagsArr ? [ ...tagsArr, hostname ] : [ hostname ]);
			} catch {
				this.set('gpMainOpts.target', tagsArr ? [ ...tagsArr, url ].join(delimiter) : url);
				this.set('tagsArr', tagsArr ? [ ...tagsArr, url ] : [ url ]);
			} finally {
				let gpUrlHandlerCb = this.get('gpUrlHandlerCb');

				gpUrlHandlerCb();
			}
		},
		handleIpVersionSwitch (ipVersion) {
			let isDisabled = this.get('isDisabled');
			let ipSwitchLocked = this.get('ipSwitchLocked');

			if (isDisabled || ipSwitchLocked) { return; }

			this.set('ipVersion', ipVersion);
			this.set('ipVersionDisplayed', ipVersion);
		},
		handleIpTypeSwitchFocus (e, tagsBlockEl) {
			tagsBlockEl.classList.remove('focused');
		},
		handleIpSwitchState () {
			let tagsArr = this.get('tagsArr');
			let ipv4regex = ipRegex.v4({ exact: true });
			let ipv6regex = ipRegex.v6({ exact: true, allowBrackets: true });

			if (tagsArr.length && tagsArr.every(target => ipv4regex.test(target))) {
				this.set('ipVersion', null);
				this.set('ipVersionDisplayed', IP_V4_VALUE);
				this.set('ipSwitchLocked', true);
			} else if (tagsArr.length && tagsArr.every(target => ipv6regex.test(target))) {
				this.set('ipVersion', null);
				this.set('ipVersionDisplayed', IP_V6_VALUE);
				this.set('ipSwitchLocked', true);
			} else if (tagsArr.some(target => ipv4regex.test(target) || ipv6regex.test(target))) {
				// hide the IP switch in the case IP versions are mixed, or there is one domain and one IP address
				let currIpVersionDisplayed = this.get('ipVersionDisplayed');
				this.set('ipVersion', null);
				this.set('ipVersionDisplayed', null);
				this.set('ipSwitchLocked', true);

				if (currIpVersionDisplayed) {
					this.set('prevIpVersionDisplayed', currIpVersionDisplayed);
				}
			} else {
				let ipVersionDisplayed = this.get('ipVersion') || this.get('ipVersionDisplayed') || this.get('prevIpVersionDisplayed') || IP_V4_VALUE;

				this.set('ipVersion', ipVersionDisplayed);
				this.set('ipVersionDisplayed', ipVersionDisplayed);
				this.set('ipSwitchLocked', false);
			}
		},
	};
</script>
